module.exports = __webpack_public_path__ + "static/media/1POLICY1.77e9898b.jpg";